module.exports = __webpack_public_path__ + "img/user.94a33ad0.jpg";